import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {MainLayoutComponent} from './layouts/main-layout/main-layout.component';
import {AuthLayoutComponent} from './layouts/auth-layout/auth-layout.component';
import {EmptyLayoutComponent} from './layouts/empty-layout/empty-layout.component';
import {DashboardLayoutComponent} from './layouts/dashboard-layout/dashboard-layout.component';
import {IconModule} from './shared';
import {NzButtonComponent} from "ng-zorro-antd/button";
import {NzTooltipDirective} from "ng-zorro-antd/tooltip";
import {NzDrawerModule} from "ng-zorro-antd/drawer";
import {NzModalModule} from "ng-zorro-antd/modal";
import {NzBadgeComponent} from "ng-zorro-antd/badge";
import {ExportTrackingComponent} from './shared/components/export-tracking/export-tracking.component';

@NgModule({
  declarations: [
    MainLayoutComponent,
    AuthLayoutComponent,
    EmptyLayoutComponent,
    DashboardLayoutComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    IconModule,
    NzButtonComponent,
    NzTooltipDirective,
    NzDrawerModule,
    NzModalModule,
    NzBadgeComponent,
    ExportTrackingComponent
  ],
  exports: [
    CommonModule,
    RouterModule,
    IconModule,
    NzTooltipDirective
  ]
})
export class SharedModule {
}
